<template>
  <v-slide-y-transition mode="out-in">   
    <v-container bg fill-height grid-list-md text-xs-center v-if="!kompetisi || firstime">
      <v-layout row wrap align-center>
        <v-flex>
          <v-progress-circular
            :size="150"
            :width="10"
            :color="$config.color"
            indeterminate>
            Loading...
          </v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card v-for="(item, i) in tabs" v-else :color="kompetisi.color" style="min-height:100vh">      
      <template v-if="!item.areaSearch && item.show">        
        <v-card-text class="pa-0">
          <v-container grid-list-xl fluid>              
            <v-layout row wrap>
              <v-flex lg6 sm6 xs12>                        
                <v-card>
                  <v-toolbar flat>
                    <v-toolbar-title>{{kompetisi.name}} - {{item.name}} </v-toolbar-title>                    
                    <v-spacer></v-spacer>                    
                    <v-chip dark :color="kompetisi.color" v-if="item.kuota">{{item.kuota}}<v-icon right>weekend</v-icon></v-chip>
                  </v-toolbar>
                  <v-card-text>                    
                    <template>
                      <e-chart :key="'a'+(item.time+item.id)" v-if="!quickcountMode" v-bind:option="setBar3Option(item)" height="78vh" width="100%" />                  
                      <e-chart :key="'b'+(item.time+item.id)" v-else v-bind:option="setBar3Option(item, true)" height="78vh" width="100%"/>                                                                                                       
                    </template>
                  </v-card-text>
                </v-card>                
              </v-flex>
              <v-flex lg6 sm6 xs12 class="tabular" style="">              
                <v-card>
                  <v-toolbar flat>    
                    <v-btn icon light @click="$router.go(-1)">
                      <v-icon color="grey darken-2">arrow_back</v-icon>
                    </v-btn>
                                       
                    <v-spacer></v-spacer>
                    <div v-if="isPlaying" class="mr-2">
                      <span class="subheading font-weight-light mr-1">LIVE</span>
                      <v-fade-transition>
                        <v-avatar                        
                          color="red"
                          :style="{
                            animationDuration: animationDuration
                          }"
                          class="mb-1 v-avatar--metronome"
                          size="12"
                        ></v-avatar>
                      </v-fade-transition>
                    </div>
                    <v-chip dark v-bind:color="quickcountMode?'warning':'success'">{{quickcountMode ? 'Quickcount':'Realcount'}}</v-chip>                                                                    
                    <v-progress-circular
                      :rotate="360"
                      :size="40"
                      :width="10"
                      :value="value"
                      class="ml-2"
                      v-bind:color="quickcountMode?'warning':'success'"
                    >
                      {{ intervalLeft }}
                    </v-progress-circular>
                    <v-menu bottom left flat>
                      <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                      <table class="v-table v-datatable grey lighten-5 flat" style="margin-top:50px">
                        <tbody>
                          <tr>
                            <td>
                              <v-btn :color="isPlaying ? 'grey':quickcountMode ? 'warning':'success'"
                                dark depressed fab small @click="toggle">
                                <v-icon>
                                  {{ isPlaying ? 'pause' : 'play_arrow' }}
                                </v-icon>
                              </v-btn>
                            </td>                        
                            <td>
                              <div>
                                <v-slider
                                  v-model="intervalTime"
                                  color="cyan"                            
                                  thumb-label="always"                           
                                  min="1"
                                  max="60"
                                >                           
                                  <v-icon
                                    slot="prepend"
                                    color="cyan"
                                    @click="intervalTime--"
                                  >
                                    remove_circle
                                  </v-icon>

                                  <v-icon
                                    slot="append"
                                    color="teal"
                                    @click="intervalTime++"
                                  >
                                    add_circle
                                  </v-icon>
                                </v-slider>
                              </div>
                            </td>
                            <td>
                              <v-btn :loading="loading" icon @click="refreshKompetisi(i)">
                                <v-icon>refresh</v-icon>            
                              </v-btn> 
                            </td>
                            <td>
                              <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
                                <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
                                ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </table>   
                    </v-menu>   
                  </v-toolbar>
                  <v-card-text>                                
                    <v-layout row wrap>
                      <v-flex lg12 sm12 xs12 ma-0 pa-0>
                        <div class="justify-center row layout ma-0 pa-0">
                          <v-chip :color="item.color" dark>
                               <v-avatar><v-icon>alarm</v-icon></v-avatar>
                               {{item.sah.updated_at?$moment(item.sah.updated_at*1000).fromNow():null}}
                          </v-chip>
                        </div>
                      </v-flex>
                      <v-flex lg4 sm4 xs4>
                        <v-card flat>
                          <v-card-text>
                            <div class="justify-center row layout ma-0">
                              <v-progress-circular
                                :size="100"
                                :width="10"
                                :rotate="360"
                                :value="persenContain(item.contain)"
                                :color="colorPersen(persenContain(item.contain))"
                                class="text-xs-center"
                              >
                                <v-icon :color="colorPersen(persenContain(item.contain))">trending_up</v-icon> {{persenContain(item.contain)}}%</span>
                              </v-progress-circular>
                            </div>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions class="justi">
                            <div class="justify-center row layout ma-0">
                              <div class="title green--text">{{quickcountMode ? item.contain.quick:item.contain.done}}</div>
                              <div class="caption"> / {{item.contain.all}} TPS</div>
                            </div>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                      <v-flex lg4 sm4 xs4 v-if="!quickcountMode">
                        <v-card flat>
                          <v-card-text>
                            <div class="justify-center row layout ma-0">
                              <v-progress-circular
                                :size="100"
                                :width="10"
                                :rotate="360"
                                :value="(item.sah.sah/item.pt*100).toFixed(2)"
                                color="blue"
                                class="text-xs-center"
                              >
                                <v-icon color="blue">accessibility</v-icon> {{(item.sah.sah/item.pt*100).toFixed(2)}}%</span>
                              </v-progress-circular>
                            </div>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <div class="justify-center row layout ma-0">
                              <span class="blue--text">{{item.sah.sah?item.sah.sah:0}}</span>/<small>{{item.pt?item.pt:0}} &nbsp; telah memilih</small>
                            </div>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                      <v-flex lg4 sm4 xs4 v-if="!quickcountMode">
                        <v-card flat>
                          <v-card-text>
                            <div class="justify-center row layout ma-0">
                              <v-progress-circular
                                :size="100"
                                :width="10"
                                :rotate="360"
                                :value="(item.sah.tdk_sah/(item.sah.tdk_sah+item.sah.sah)*100).toFixed(2)"
                                color="red"
                                class="text-xs-center"
                              >
                                <v-icon color="red">layers_clear</v-icon><br/> {{item.sah.tdk_sah?item.sah.tdk_sah:0}}</span>
                              </v-progress-circular>
                            </div>                            
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <div class="justify-center row layout ma-0">
                              <small>Tidak Sah</small>
                            </div>
                          </v-card-actions>
                        </v-card>
                      </v-flex>                      
                    </v-layout>
                                        
                  </v-card-text>
                </v-card>                                 
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                      :headers="[  
                        {text:'No',value:'index',sortable:false},
                        {text:'Urut',sortable:false,value:'no',align:'center'},
                        {text:'',value:'i',sortable:false},{ text: 'Rank Sementara', value:'value'},
                        {text:'Suara',sortable:false,value:'value'}
                      ]"
                      :items="item.calons"  
                      :pagination.sync="pagination"
                      hide-actions
                      >
                      <template slot="items" slot-scope="props"> 
                        <tr :style="(props.index+1)<=item.kuota? 'background:#D4FFD4':''">      
                          <td>{{props.index+1}}</td>
                          <td>
                            <v-chip :color="props.item.color" dark>{{props.item.no}}</v-chip>                                  
                          </td>
                          <td>
                            <v-avatar size="35">
                              <img :src="props.item.thumb ? props.item.thumb :require('@/assets/img/avatar/blank-dpd.jpg')">
                            </v-avatar>
                          </td>
                          <td>                                
                              <v-list-tile-title v-html="props.item.name"></v-list-tile-title>                                 
                          </td>     
                          <td>
                            <span class="subheading" v-if="!quickcountMode">{{props.item.value?props.item.value:0}} %</span>
                            <span class="subheading" v-else>{{props.item.hitung.quickcount?props.item.hitung.quickcount:0}} %</span>
                          </td>
                        </tr>                            
                      </template>

                    </v-data-table>
                  </v-flex>
                </v-layout>            
              </v-flex>
            </v-layout>
          </v-container>  
        </v-card-text>
      </template>  
    </v-card>                
  </v-slide-y-transition>
</template>

<script>  
import EChart from '@/components/chart/echart';    
import DBar3  from '../../components/data-chart/bar-3';
import Model  from '@/apps/frc/models/Dashboard';   
const  model = new Model();

export default {    
    components: {
      EChart
    },
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      interval: {},
      intervalTime:15,
      intervalLeft:0,
      value: 0,
      isPlaying: true,
      tabs : [],
      active : 0,
      search : [], 
      kompetisi_id : null,
      kompetisi : null,                      
      loading  : true,
      firstime : true,
      pagination : {'sortBy': 'value', 'descending': true, 'rowsPerPage': -1},      
      quickcountMode : false,         
      maxvalue: 0,
    }),     
    watch:{      
      isPlaying(newVal){
        if(newVal){
          this.playing();
        }else{
          clearInterval(this.interval)
        }
      },
      intervalTime(newVal){
        if(newVal < 1){
          this.intervalTime = 1;
        }
      }
    },
    computed:{
      animationDuration () {
        return `${60 / 80}s`
      }
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted(){ 
      this.init();
      
    },                   
    created () {},
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},                                
        
        toggle () {
          this.isPlaying = !this.isPlaying
        },
        
        playing(){
          this.interval = setInterval(() => {
            if (this.value <= 0) {
              if(this.tabs[0]){
                this.refreshKompetisi(0)
              }
              this.intervalLeft = this.intervalTime;
              return (this.value = 100)
            }
            this.value -= 100/this.intervalTime;
            this.intervalLeft -= 1;
          }, 1000);
        },
        
        init(){                      
          if(this.kompetisi_id !== this.$route.query.kompetisi_id){
            //this.loading = true;            
            this.kompetisi_id = this.$route.query.kompetisi_id;
            model.kompetisi({id:this.$route.query.kompetisi_id, noattr:1}).then(res=>{                  
                let index = 0;                 
                this.kompetisi = res.data;                           
                this.newTab(res.data,index);                
            });
          }                                        
        },
        
        newTab(data, i){
            if(data.tingkat < 5){   
                for(let j=this.tabs.length; j >= i ; j--){
                    this.tabs.splice(j, 1);                    
                }
                
                data.time = 0;
                data.calons = [];
                
                if(!this.tabs[i]){                    
                    this.tabs.push({name:data.name, calons:[], area_ids:[],show:false , tingkat_ids:[],areaSearch:null, area:{data:[], count:0, page:1, time:null}});                                 
                    let ctx= this; setTimeout(function(){ctx.tabs[i].show= true;},100);
                }                   
                       
                Object.assign(this.tabs[i], data);                
                //this.refreshKompetisi(i);                
                this.active = i;                                                                  
                this.playing();

                
                
            } else {
                //this.formRoute(data.id);                
            }
        },
        
        setCalons(i){ 
            let total_suara = 0
            this.tabs[i].calons.forEach((item, j)=>{ 
                var value = this.quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? value : 0
                total_suara += parseInt(value); 
            })
            this.tabs[i].calons.forEach((item, j)=>{                
                var value = this.quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? parseFloat(parseInt(value)/total_suara*100) : 0
                value = value ? value.toFixed(2) : 0
                this.tabs[i].calons[j].value = value;  
            });            
        },
        
        refreshKompetisi(i){          
          let fm = this.tabs[i];          
          this.loading =true;
          if(i > 0){
           
          } else {
            model.dapils({'DapilSearch[id]':this.$route.query.dapil_id,kompetisi_id:this.$route.query.kompetisi_id}).then(res=>{
                Object.assign(fm, res.data.data[0]);
                this.setCalons(i);                
                this.loading  = false;
                this.firstime = false;
            });
          }
        },
                  
        persenContain(contain){
            return this.quickcountMode ? (contain.quick/contain.all*100).toFixed(2):(contain.done/contain.all*100).toFixed(2);
        },

        colorPersen(persen){
            if(persen >= 0 && persen <=40)return 'red';
            else if(persen <=60)return 'orange';
            else if(persen <=80)return 'yellow';
            else if(persen <=99)return 'blue';
            else return 'green';        
        },
        
        firstLetter (name) {
            return name.charAt(0);
        },                                                          
        
        setBar3Option(data, quickcountMode=false){            
            let newOption  = JSON.parse(JSON.stringify(DBar3.option));
            let seriesData = [], legendData = [], arrval=[]; this.calons = [];     
            let total_suara = 0;   
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? value : 0
                total_suara += parseInt(value);
            })
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value > 0 ? value : 0;
                value = parseFloat(value/total_suara*100);
                value = value > 0 ? value.toFixed(2):0
                
                var name  = item.no+'. '+item.akronim;
                arrval.push(value);
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(item.no);                
            });
            newOption.series[0].data = seriesData;  
            newOption.series[0].markLine.data[0] = {name: 'Batas Kuota', yAxis:this.getMinKuota(arrval, data.kuota)};
            newOption.xAxis[0].data  = legendData;
            newOption.series[0].label = {
              formatter: function(d) {
                return d.data+'%';
              }
            }
            
            //newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },                               
        
        getMinKuota(arr, kuota){
          arr.sort(function(a,b){
              return b-a;
          });
          return arr[kuota-1]?arr[kuota-1]:0;
        },  
        
        urutkan(arrA, arrB){
            for(var i=0; i<arrA.length; i++){
              for(var j=i+1; j<arrA.length; j++){
                if(arrA[i]>arrA[j]){
                    var tmpA=arrA[i]; var tmpB=arrB[i]; 
                    arrA[i]=arrA[j];  arrB[i]=arrB[j];
                    arrA[j]=tmpA;     arrB[j]=tmpB;
                }     
              }   
            }
            var result = [];
            for(var i=0; i<arrA.length; i++){
              result.push({a:arrA[i], b:arrB[i]});
            }            
            return result;            
        }
    }
}
</script>
<style>
  @keyframes metronome-example {
    from {
      transform: scale(.5);
    }

    to {
      transform: scale(1);
    }
  }

  .v-avatar--metronome {
    animation-name: metronome-example;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
</style>
  
